export const TYPE_PLAYER_RELEASE = 'player';
export const TYPE_SITE_RELEASE = 'microsite';
export const TYPE_BLOCK = 'block';
export default [TYPE_PLAYER_RELEASE, TYPE_SITE_RELEASE, TYPE_BLOCK];
